
import { mapGetters } from "vuex";
import LazyHydrate from "vue-lazy-hydration";
import SpTestimonials from "~/components/v2/splash/sp-testimonials.vue";
import SpReviews from "~/components/v2/splash/sp-reviews.vue";
import SpLocations from "~/components/v2/splash/sp-locations.vue";
import SpAbbreviations from "~/components/v2/splash/sp-abbreviations.vue";
import SpTopPart from "~/components/v2/splash/sp-top-part.vue";
import { HOME_PAGE_META } from "~/common/seo/seo-policy";

export default {
  components: {
    LazyHydrate,
    SpTopPart,
    SpTestimonials,
    SpBanner: () => import("~/components/v2/splash/sp-banner.vue"),
    SpReviews,
    SpLocations,
    SpPhotoGallery: () => import("~/components/v2/splash/sp-photo-gallery.vue"),
    SpVideoList: () => import("~/components/v2/splash/sp-video-list.vue"),
    SpAbbreviations,
  },

  layout: "splash",

  middleware: ["splash"],

  async fetch({ store }) {
    await store.dispatch("sliders/getMainPageData");
  },

  head() {
    return {
      title: this.pageSeoMeta.title,
      link: [{ rel: "canonical", href: this.$config.baseUrlApp }],
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            this.seoTexts?.description || this.$t("seo.main.description"),
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.pageSeoMeta.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            this.seoTexts?.description || this.$t("seo.main.og-description"),
        },
      ],
    };
  },

  computed: {
    ...mapGetters({
      seoTexts: "global/getSeoTexts",
    }),
    pageSeoMeta() {
      return HOME_PAGE_META;
    },
    isAuthenticated() {
      return this.$auth.loggedIn;
    },
    isMobile() {
      return this.$store.state.global.mobile;
    },
  },
};
